import React from "react";

const RiskIcon = ({ color = "#37B450" }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.5H1C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5V5C0 8.295 1.595 10.2919 2.93313 11.3869C4.37437 12.5656 5.80813 12.9656 5.87063 12.9825C5.95656 13.0059 6.04719 13.0059 6.13313 12.9825C6.19563 12.9656 7.6275 12.5656 9.07063 11.3869C10.405 10.2919 12 8.295 12 5V1.5C12 1.23478 11.8946 0.98043 11.7071 0.792893C11.5196 0.605357 11.2652 0.5 11 0.5ZM8.855 4.85375L5.355 8.35375C5.30856 8.40024 5.25342 8.43712 5.19272 8.46228C5.13202 8.48744 5.06696 8.50039 5.00125 8.50039C4.93554 8.50039 4.87048 8.48744 4.80978 8.46228C4.74908 8.43712 4.69394 8.40024 4.6475 8.35375L3.1475 6.85375C3.05368 6.75993 3.00097 6.63268 3.00097 6.5C3.00097 6.36732 3.05368 6.24007 3.1475 6.14625C3.24132 6.05243 3.36857 5.99972 3.50125 5.99972C3.63393 5.99972 3.76118 6.05243 3.855 6.14625L5 7.29313L8.14625 4.14625C8.19271 4.09979 8.24786 4.06294 8.30855 4.0378C8.36925 4.01266 8.4343 3.99972 8.5 3.99972C8.5657 3.99972 8.63075 4.01266 8.69145 4.0378C8.75214 4.06294 8.80729 4.09979 8.85375 4.14625C8.90021 4.1927 8.93705 4.24786 8.9622 4.30855C8.98734 4.36925 9.00028 4.4343 9.00028 4.5C9.00028 4.5657 8.98734 4.63075 8.9622 4.69145C8.93705 4.75214 8.90021 4.8073 8.85375 4.85375H8.855Z"
        fill={color}
      />
    </svg>
  );
};

export default RiskIcon;
